/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch } from 'react-redux'
import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'
import moment from 'moment';
// import {  } from "@material-ui/core";
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Grid, FormGroup, IconButton } from '@material-ui/core'; // Remove the unused imports for CHG0073013
import { useHistory } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import { SearchOutlined } from '@material-ui/icons';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MdReplay } from 'react-icons/md';
import styles from './ViewBookingsDatewise.module.css'
import { CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
import { API } from '../../apis/api'
// import TextIcon from './TextIcon'
import { buildErrorMessage } from '../../apis/calls'
import Table from '../Table/Table';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { AuthChecker, Button } from '../../atomicComponents';
import { withAllowedOperationsProvider } from '../../hocs'
import { setToast, setPORow, poSearch, fetchChassis, setChassisData, setAllDetails, getInvoice } from '../../redux/actions/productsActions';
import TableSimple from '../../atomicComponents/TableSimple/TableSimple';



const initialState = {
    plant: null,
    part: null,
    aqCommodity: null,
    purchaseCommodity: null,
    supplierCode: null,
    supplierDetails: null,
    supplierName: '',
    supplierLocation: '',
    selectedProject: null,
    selectedPO: null,
    inputFields: {
        purchaseBuyerName: '',
        suppRepresentativeName: '',
        suppRepresentativeContact: '',
        suppRepresentativeEmail: ''
    },
    errors: {},
}
const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return {
                ...state,
                [action.field]: action.value
            }
        case 'reset':
            return {
                ...state,
                ...initialState
            }
        default:
            return state
    }
}

function ViewBookingsDatewise({ redirectToProcessPage, product, counter, baseUrl, auth }) {
    const ROW_HEIGHT = 38;
    const [rowsData, setRowsData] = useState({
        loading: false,
        data: [],
        filteredData: [],
    });
    const [poData, setPOData] = useState({
        loading: false,
        data: [],
        filteredData: [],
        last: false,
        number: 0
    });
    const [state, dispatch] = useReducer(reducer, initialState);
    const { showInternalError } = usePopupManager();
    const { showPopup } = usePopupManager();
    const dispatch1 = useDispatch();
    const history = useHistory();



    const { damage, invoice, plant, part, aqCommodity, purchaseCommodity, supplierCode, supplierDetails, supplierName,
        supplierLocation, selectedProject, selectedPO, inputFields, errors } = state;


    const [suppliers, getSuppliers] = useState({ loading: false, data: [] });
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [confirmModalFlag, setConfirmModal] = useState(false);
    const [confirmModalFlag2, setConfirmModal2] = useState(false);
    const [deleteParam, handleDeleteParam] = useState();
    const [deleteParam2, handleDeleteParam2] = useState();
    const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
    const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(false);


    const [toggle, setToggle] = React.useState(false);
    const [loader, setLoader] = React.useState(true);
    const [hover, setHover] = useState({ isHover: false, name: null });
    const [bodyBuilderOption, setBdybuilderOption] = useState([]);
    const [chassisOption, setChassisData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [asnCount, setAsnCount] = useState(0);

    const [companyCodeOption, setCompanyCode] = useState([]);


    const [myState, setState] = React.useState(
        {
            poNo: "",
            stmNo: "",
            chassisNo: null,
            toDate: null,
            fromDate: null,
            bodyBuilder: null,
            checkFlag: false,
            tableFlag: false
        });

    const setCount = count => {
        setAsnCount(count);
    };
    const handleDate = (date, name) => {
        //  let newvalue = convert(date);
        if (date == null) {
            setState((prevData) => ({ ...prevData, [name]: null }));
            return;

        }
        let newDate = date.format(DATE_FORMAT.ISO)
        setState((prevData) => ({ ...prevData, [name]: newDate }));

    }

    const resetError = (name) => {
        if (name == "chassisNo") {
            strflag();
            //    setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }));
        }



    }

    const onChangeHandler = (event) => {
        const { name, value } = event.target;
        setState((prevData) => ({
            ...prevData, [name]: value
        }));
        resetError(name);

    }

    const handleSelect = (selectedOption, name) => {
        if (selectedOption == null) {
            setState((prevData) => ({
                ...prevData,
                [name]: null
            }));
            return;
        }

        if (name == "bodyBuilder") {

            //   alert(selectedOption + name)

            setState((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
            getBodyBuilderChassis(selectedOption)

        } else {
            setState((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
        }


    }
    useEffect(() => {
        asyncPostCall()
    }, [])

    function handleClickOpen1(flag = null) {
        let regurlarFlag = strflag();

        if (regurlarFlag == true)
        // eslint-disable-next-line no-empty
        { } else {
            return false;
        }
        resetError('chassisNo')
        asyncPostCall()


    }

    const asyncPostCall = async () => {
        let bb = [auth.userID]
        const userId = auth.userID;
        //  const userId=auth.userID.toUpperCase();
        // const userId="t66471"

        try {

            let apiFormatedData = {
                userRole: auth.userRole,
                userId,
            }
            var apiFormatedDataJson = JSON.stringify(apiFormatedData);
            let headerss = new Headers();
            headerss.append('Content-Type', 'application/json');
            const response = await fetch(`${baseUrl}reports/rptGetBbList`,
                {
                    method: 'POST',
                    headers: headerss,
                    credentials:'include',
                    body: apiFormatedDataJson
                })
            const responseJson = await response.json();
            const bdybuilderOption = responseJson.c_getBbList.map(({ bb_code, bb_name }) => ({ value: bb_code, label: bb_name }));
            if (auth.userRole == "vendor") {
                const status = bdybuilderOption.filter(o => o.value == userId);
                setBdybuilderOption(status)
                setState((prevData) => ({ ...prevData, bodyBuilder: status, checkFlag: true }));
                getBodyBuilderChassis(status)
            } else {
                setBdybuilderOption(bdybuilderOption)
            }

        } catch (error) {
            // enter your logic for when there is an error (ex. error toast)

            console.log(error)
        }
    }
    function handleClose1() {
        setOpen1(false);
    }

    const setDaat = (data) => {
        const { PONo, vcbcNo } = data;

        setState((prevData) => ({
            ...prevData,
            PONo, vcbcNo,
        }));
        setOpen1(false);

    }

    const handlePrompt = (param) => {
        handleDeleteParam(param)
        handleOpen1();

    };
    const handlePrompt2 = (param) => {
        handleDeleteParam2(param)
        handleOpen2();

    };


    const chassisNoCheckFlag = (status) => {

        let chassisNo = myState.chassisNo;
        if (chassisNo == "" || chassisNo == null) {
            setState((prevData) => ({ ...prevData, chassisNoFlag: true }))
            return false
        }
        else {
            setState((prevData) => ({ ...prevData, chassisNoFlag: false }))

            return true

        }

    }

    const BodybuilderCodeCheck = (status) => {

        let bodybuilderCode = myState.bodybuilder;
        if (bodybuilderCode == "" || bodybuilderCode == null) {
            setState((prevData) => ({ ...prevData, bodyBuilderFlag: true }))
            return false
        }
        else {
            setState((prevData) => ({ ...prevData, bodyBuilderFlag: false }))

            return true

        }

    }



    const strflag = () => {
        var regexp = new RegExp(/^[a-zA-Z0-9 ]+$/);
        let str = myState.chassisNo;
        if (myState.chassisNo == "") {
            return
        }

        if (regexp.test(str)) {


            setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }))
            return true
        }
        else {
            setState((prevData) => ({ ...prevData, chassisNoFlagStr: true }))
            return false

        }

    }




    const convert2 = (str) => {
        if (str == null) {
            return '';
        } else {


            const date = new Date(str);
            const mnth = (`0${date.getMonth() + 1}`).slice(-2);
            const day = (`0${date.getDate()}`).slice(-2);
            //  return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29 

            return [mnth, day, date.getFullYear()].join("-"); // 03/08/2022
        }
    }

    const showError = (msg) => {
        showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: msg,
        });
    }

    const validateInvoiceData = (dateReport) => {

        let fromDate = myState.fromDate;
        let toDate = myState.toDate;
        let getinvoiceDate = myState.toDate;
        let invoiceDate = moment(toDate, 'YYYY-MM-DD').valueOf();
        let reportedDate = moment(fromDate, 'YYYY-MM-DD').valueOf(); // 'YYYY-MM-DD'
        //  Reported date should not be less than invoice date

        if (invoiceDate > reportedDate) {

            console.log(invoiceDate, "==invoiceDate", reportedDate, "dateReport", "If")
            return true;
        }
        else if (invoiceDate == reportedDate) {
            return true;
        } else {
            console.log(invoiceDate, "==invoiceDate", reportedDate, "dateReport", "else")

            showError("From date should not greater than to date")

            return false;
        }

    }
    const validateDay = () => {
        let startDate = myState.fromDate;
        let endDate = myState.toDate;
        const diffInMs = new Date(endDate) - new Date(startDate)
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        if (diffInDays >= 90) {
            showError("Both date gap should not exceeds 90 days")
            return false;
        } else {
            return true;
        }
    }

    const getBodyBuilderChassis = async (bodyBuilderParam) => {
        try {



            let bodyBuilder = bodyBuilderParam;
            let fromDate = convert2(myState.fromDate);
            let toDate = convert2(myState.toDate);
            if (bodyBuilder == null) {
                bodyBuilder = []
            } else {
                bodyBuilder = bodyBuilder.map(({ value }) => (value));
            }

            if (fromDate == '' || toDate == '')
            // eslint-disable-next-line no-empty
            {

            } else {
                let Test = validateInvoiceData();
                let Test2 = validateDay();
                if (!Test && !Test2) {
                    return
                }
            }



            let apiFormatedData = {
                chassisNo: [],
                bbCode: bodyBuilder,
                fromDate,
                toDate

            }
            var apiFormatedDataJson = JSON.stringify(apiFormatedData);
            let headerss = new Headers();
            headerss.append('Content-Type', 'application/json');
            const token = sessionStorage.getItem('token')
            const sessionId = sessionStorage.getItem('sessionId')
            headerss.append('X-Session-Id', sessionId)
            headerss.append("authorization", `Bearer ${token}`);
            const response = await fetch(`${baseUrl}reports/rptGetChassisDetails`,
                {
                    method: 'POST',
                    headers: headerss,
                    body: apiFormatedDataJson
                })
            const responseJson = await response.json();
            if (responseJson.msg == "fail") {

                showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: "No Records",
                });
            } else {
                const chassisOption = responseJson.c_ChassisDetails.map(({ chs_no }) => ({ value: chs_no, label: chs_no }));
                setChassisData(chassisOption)
            }

        } catch (error) {
            showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: error,

            });
        }
    }


    const handleSubmit = async () => {
        try {

            let chassisNo = myState.chassisNo;
            let bodyBuilder = myState.bodyBuilder;
            let fromDate = convert2(myState.fromDate);
            let toDate = convert2(myState.toDate);

            if (bodyBuilder == null) {
                bodyBuilder = []
            } else {
                bodyBuilder = myState.bodyBuilder.map(({ value }) => (value));

            }
            if (chassisNo == null) {
                chassisNo = []
            } else {
                chassisNo = myState.chassisNo.map(({ value }) => (value));

            }

            if (fromDate == '' || toDate == '')
            // eslint-disable-next-line no-empty
            {

            } else {
                let Test = validateInvoiceData();
                let Test2 = validateDay();
                if (!Test && !Test2) {
                    return
                }
            }



            // let flag5 = chassisNoCheckFlag();
            // let flag1 = BodybuilderCodeCheck();
            // let flag3 = validateDate();
            // if (flag1 == true && flag5 == true)
            // // eslint-disable-next-line no-empty
            // { } else {
            //   return false;
            // } 




            let apiFormatedData = {
                chassisNo: chassisNo,
                bbCode: bodyBuilder,
                fromDate,
                toDate

            }


            var apiFormatedDataJson = JSON.stringify(apiFormatedData);
            let headerss = new Headers();
            headerss.append('Content-Type', 'application/json');
            const response = await fetch(`${baseUrl}reports/rptChassisDetails`,
                {
                    method: 'POST',
                    headers: headerss,
                    credentials:'include',
                    body: apiFormatedDataJson
                })
            const responseJson = await response.json();
            if (responseJson.msg == "fail") {

                showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: "No Records",
                });
                setTableData([])

            } else {
                let excelRow = responseJson.data.map(({
                    status,
                    chs_no,
                    chs_stm_no,
                    chs_vcbc_no,
                    chs_bb_id,
                    body_sr_no,
                    mfg_complete_date,
                    mfg_start_date,
                    chs_po,
                    demerit_sts,
                    created_on,
                    demerit_on,
                    demerit_by,
                    inv_no,
                    inv_date,
                    inv_amt,
                    entry_date,
                    transp_code,
                    gr_no,
                    gr_amt,
                    gr_dt,
                    chs_vcdesc1,
                    chs_country,
                    chs_evrcombo,
                    hydraulic_kit_no,
                    bb_name,
                    roll_out_score,
                    disp_score }) => {

                    let obj = {
                        "Chassis Status": status,
                        "Chassis No": chs_no,
                        "VC No": chs_stm_no,
                        "VCBC No": chs_vcbc_no,
                        "VC Description": chs_vcdesc1,
                        "Boby Builder Name": bb_name,
                        "Body Builder Code": chs_bb_id,
                        "Body Builder SR": body_sr_no,
                        "Mfg Complete Date": mfg_complete_date,
                        "Mfg. Estimate Date": mfg_start_date,
                        "PO No": chs_po,
                        "Demerit Status": demerit_sts,
                        "Created On": created_on,
                        "Demerit On": demerit_on,
                        "Demerit By": demerit_by,
                        "Invoice NO": inv_no,
                        "Invoice Date": inv_date,
                        "Invoice Amount": inv_amt,
                        "Entry Date": entry_date,
                        "Transporter Code": transp_code,
                        "GR No": gr_no,
                        "GR Amount": gr_amt,
                        "GR Date": gr_dt,
                        "Country": chs_country,
                        "EVR Combo": chs_evrcombo,
                        "Hydraulic Kit No": hydraulic_kit_no,
                        "Roll Out Score": roll_out_score,
                        "Dispatch Score": disp_score
                    }
                    return obj;

                }
                );
                exportExcel(excelRow)
                const tableRows = responseJson.data.map((item, id) => Object.assign(item, id))

                setTableData(tableRows)



            }

        } catch (error) {
            showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: error,

            });
        }
    }
    const handleViewclick = async () => {
        setState(prevState => ({ ...prevState, tableFlag: true }))
    }

    // const handleCancelclick = async () => {
    //     setState(prevState => ({ ...prevState, toDate: null }))
    //     setState(prevState => ({ ...prevState, fromDate: null }))
    //     setState(prevState => ({ ...prevState, tableFlag: false }))
    // }
    const exportExcel = async (excelRowData) => {

        var fileTypel = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        var fileExt = ".xlsx"
        var fileName = "Report" + moment().format("DD/MM/YYYY LT");


        const ws = XLSX.utils.json_to_sheet(excelRowData)
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { booktype: 'xlsx', type: 'array' })
        const data = new Blob([excelBuffer], { type: fileTypel });
        FileSaver.saveAs(data, `${fileName}${fileExt}`);
    }


    const handleSubmit1 = () => {
        let chassisNo = myState.chassisNo;
        let bodyBuilder = myState.bodyBuilder;
        let fromDate = myState.fromDate;
        let toDate = myState.toDate;

        if (bodyBuilder == null) {
            bodyBuilder = []
        } else {
            bodyBuilder = myState.bodyBuilder.map(({ value }) => (value));

        }
        if (chassisNo == null) {
            chassisNo = []
        } else {
            chassisNo = myState.chassisNo.map(({ value }) => (value));

        }

        if (fromDate == null) {
            fromDate = ''
        }
        if (toDate == null) {
            toDate = ''
        }



        // let flag5 = chassisNoCheckFlag();
        // let flag1 = BodybuilderCodeCheck();
        // let flag3 = validateDate();
        // if (flag1 == true && flag5 == true)
        // // eslint-disable-next-line no-empty
        // { } else {
        //   return false;
        // } 




        let apiFormatedData = {
            chassisNo: chassisNo,
            bbCode: bodyBuilder,
            fromDate,
            toDate

        }

        var apiFormatedDataJson = JSON.stringify(apiFormatedData);
        console.log("final", apiFormatedDataJson);
        let headerss = new Headers();
        headerss.append('Content-Type', 'application/json');
        const token = sessionStorage.getItem('token')
        const sessionId = sessionStorage.getItem('sessionId')
        headerss.append('X-Session-Id', sessionId)
        headerss.append("authorization", `Bearer ${token}`);
        fetch(`${baseUrl}reports/rptChassisDetails`,
            {
                method: 'POST',
                headers: headerss,
                body: apiFormatedDataJson
            }).then((response) => response.json())
            .then((responseJson) => {

            })
            .catch((error) => {
                showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: "Enternal server error",

                });
            });

    };






    const onHover = (name) => {
        setHover({ isHover: true, name: name });
    };

    const onLeave = () => {
        setHover({ isHover: false, name: null });
    };

    const BG_COLOR = '#fffef8';
    const [backgroundColors, setBackgroundColors] = useState({
        processInfoBg: true,
        supplierInfoBg: false,
        poInfoBg: false,
        projectsInfoBg: false
    });
    const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } = backgroundColors;

    const changeBackgroundColor = (field) =>
        setBackgroundColors(prev => {
            const newBackgroundColors = {};
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value] of Object.entries(prev)) {
                if (key === field)
                    newBackgroundColors[key] = true;
                else
                    newBackgroundColors[key] = false;
            }
            return newBackgroundColors
        })


    const loadSupliers = async () => loadData(getSuppliers, API_RESOURCE_URLS.getSuppliers(),
        { plantCode: plant ? plant.value : null, partNumber: part ? part.value : null });
    const handleOpen = () => setIsPopupOpen(true);
    const handleClose = () => setIsPopupOpen(false);
    const handleOpen1 = () => {
        setConfirmModal(true);


    };
    const handleOpen2 = () => {
        setConfirmModal2(true);


    };
    const handleClose2 = () => setConfirmModal2(false);
    const resetFields = () => {
        // if (myState.checkFlag == true) {
        //     setState((prevData) => ({
        //         ...prevData,
        //         chassisNo: null,
        //         toDate: null,
        //         fromDate: null,
        //     }));
        // } else {
        //     setState((prevData) => ({
        //         ...prevData,
        //         chassisNo: null,
        //         toDate: null,
        //         fromDate: null,
        //         bodyBuilder: null,
        //     }));
        // }
        setState(prevState => ({ ...prevState, toDate: null }));
        setState(prevState => ({ ...prevState, fromDate: null }));
        setState(prevState => ({ ...prevState, tableFlag: false }));
        setTableData([])
        setHighlightMandatoryFields(false)

    }

    const processProjectList = projectList => {
        let processedProjectList = projectList.map(({ ...project }) => {
            const allPlants = project.plants.map(item => item.name);
            const allVehicleLines = project.vehicleLines;
            const projectCreationDate = moment(project.createdAt).format("DD/MM/YYYY");
            return {
                id: project.id,
                ...project,
                allPlants,
                allVehicleLines,
                projectCreationDate
            }
        });
        const allPlantsList = [];
        const allVehicleLineList = [];
        processedProjectList.forEach(({ allPlants, vehicleLines }) => {
            allPlantsList.push(...allPlants);
            allVehicleLineList.push(...vehicleLines);
        });

        processedProjectList = processedProjectList.map(({ ...project }) => (
            {
                ...project,
                allPlants: [...new Set(allPlantsList)],
                allVehicleLines: [...new Set(allVehicleLineList)],
            }
        ));
        return processedProjectList;
    }
    const loadAllProjects = async () => {
        try {
            setRowsData(prev => ({
                ...prev,
                loading: true,
            }));

            const response = await API.get(
                API_RESOURCE_URLS.PROJECTS
            );

            const { data: projectList } = response;
            const processedProjectList = processProjectList(projectList);

            setRowsData({
                data: processedProjectList,
                filteredData: processedProjectList,
                loading: false,
            });
        } catch (error) {
            showInternalError(error);
            console.error(buildErrorMessage(error));
            setRowsData({
                data: [],
                filteredData: [],
                loading: false,
            });
        }
    };





    const getSupplierDetails = () => {
        if (suppliers && suppliers.data && supplierCode) {
            const findSupplier = suppliers.data.find(x => x.code === supplierCode.value);
            if (findSupplier) {
                dispatch({ type: 'update', field: 'supplierDetails', value: findSupplier });
                dispatch({ type: 'update', field: 'supplierName', value: findSupplier.name });

                const address = { value: findSupplier.address[Object.keys(findSupplier.address).sort().pop()], ...findSupplier.address }
                dispatch({ type: 'update', field: 'supplierLocation', value: Object.values(address).filter(x => x !== '').join(',') });

            }
        }
    }




    const baseDefaultColumns = [
        {
            width: 180,
            title: 'Booking Date',
            field: 'BookingDate',
            enableSearch: true,
            enableFilter: true,
        },
        {
            width: 180,
            title: 'Project Code',
            field: 'ProjectCode',
            enableSearch: true,
            enableFilter: true,
        },
        {
            width: 180,
            title: 'Project Description',
            field: 'ProjectDescription',
            enableSearch: true,
            enableFilter: true,
        },
        {
            width: 180,
            title: 'Aggregate',
            field: 'Aggregate',
            enableSearch: true,
            enableFilter: true,
        },
        {
            width: 180,
            title: 'Activity',
            field: 'Activity',
            enableSearch: true,
            enableFilter: true,
        },
        {
            width: 180,
            title: 'Hours',
            field: 'Hours',
            enableSearch: true,
            enableFilter: true,
        },
        {
            width: 180,
            title: 'Booking Type',
            field: 'BookingType',
            enableSearch: true,
            enableFilter: true,
        },
        {
            width: 180,
            title: 'Approval Status',
            field: 'ApprovalStatus',
            enableSearch: true,
            enableFilter: true,
        },


    ];
    const processPoList = poList => {
        const processedPoList = poList.map(({ ...po }) => {
            const plantName = po.plant.name;
            const partDesc = po.part.description;
            const id = po.number;
            const processCreationDate = moment(po.createdAt).format("DD/MM/YYYY");
            return {
                ...po,
                id,
                plantName,
                partDesc,
                processCreationDate
            }
        });
        return processedPoList;
    }

    const loadPO = async () => {
        try {
            setPOData(prev => ({
                ...prev,
                loading: true,
            }));

            const response = await API.get(
                API_RESOURCE_URLS.PURCHASE_ORDER,
                {
                    params:
                    {
                        supplierId: supplierDetails ? supplierDetails.id : null,
                        partNumber: part ? part.value : null,
                        plantCode: plant ? plant.value : null,
                        page: poData.number,
                    }
                }
            );
            const processedPoList = processPoList(response.data.content);

            setPOData(prev => ({
                ...prev,
                data: [...prev.data, ...processedPoList],
                filteredData: [...prev.filteredData, ...processedPoList],
                loading: false,
                last: response.data.last
            })
            );

        } catch (error) {
            showInternalError(error);
            console.error(buildErrorMessage(error));
            setPOData({
                number: 0,
                data: [],
                filteredData: [],
                loading: false,
                last: false
            });
        }
    };

    const handleValidation = (event, field) => {
        let err = errors;
        const { value } = event.target;

        switch (field) {
            case 'purchaseBuyerName':
                err['purchaseBuyerName'] = value ? RegExp(Regex.name).test(value) ? '' : 'Name is invalid' : 'Name is required';
                break;

            case 'suppRepresentativeName':
                err['suppRepresentativeName'] = value ? RegExp(Regex.name).test(value) ? '' : 'Name is invalid' : 'Name is required';
                break;

            case 'suppRepresentativeEmail':
                err['suppRepresentativeEmail'] = value ? RegExp(Regex.email).test(value) ? '' : 'Email is invalid' : 'Email is required';
                break;

            case 'suppRepresentativeContact':
                err['suppRepresentativeContact'] = value ? RegExp(Regex.phone).test(value) ? '' : 'Contact is invalid' : 'Contact is required';
                break;

            default:
                break;
        }
        dispatch({ type: 'update', field: 'errors', value: err });
    }

    const renderStatic = () => (

        <div
            className={styles.formGroup}
            style={{ backgroundColor: processInfoBg }}
            onClick={() => changeBackgroundColor('processInfoBg')}
        >

            <Grid
                container
                spacing={1}

                style={{ display: 'flex', justifyContent: "center" }}
                columns={12}
            >
                <Grid item md={4} lg={4}>
                    <div className={styles.rowDiv}>
                        <div className={clsx(styles.lableDiv)}>
                            <label>Chassis No*</label>
                        </div>
                        <div className={styles.formDiv}>

                            {/* <TextIcon
                style={{ width: '100%' }}
                isMandatory
                validationFn={(value) => value.length > 0}
                markIfEmpty={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                validationHelperText="error occured"
                variant="outlined"
                size="small"
                value={myState.chassisNo}
                name="chassisNo"
                onChange={onChangeHandler}
                placeholder="Enter Chassis "
                className={styles.textField}
                inputProps={{

                  className: styles.textInput,
                  "data-testid": "representative-name-input",

                }}
                FormHelperTextProps={{
                  className: styles.helperText,
                }}
                handleClickOpen1={handleClickOpen1}
              /> */}
                        </div>
                    </div>
                    {myState.chassisNoFlag &&
                        // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
                        <div style={{ marginLeft: "35px" }} className={styles.error}>Chassis No is mandatory field</div>

                    }
                    {myState.chassisNoFlagStr &&
                        <div style={{ marginLeft: "65px" }} className={styles.error}>special characters are not allowed</div>

                    }

                </Grid>



            </Grid>
        </div>
    );

    const renderOther = () => (
        <div
            className={styles.formGroup}
            // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
            onClick={() => changeBackgroundColor('processInfoBg')}
        >
            <Grid
                container
                spacing={1}

                style={{ display: 'flex', justifyContent: "left", marginTop: "10px" }}
                columns={12}
            >
                <Grid item md={4} lg={4}>
                    <div className={styles.rowDiv}>
                        <div className={clsx(styles.lableDiv)}>
                            <label>From Date</label>
                        </div>
                        <div className={styles.formDiv}>

                            <CustomDatePicker

                                clearable
                                // markIfUnselected={highlightMandatoryFields}
                                autoOk
                                inputVariant="outlined"
                                value={myState.fromDate}
                                onChange={(e) => { handleDate(e, 'fromDate') }}
                                inputProps={{
                                    className: clsx(styles.select, styles.dateInput),

                                }}
                                emptyLabel="dd/mm/yyyy"
                                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                                format="DD/MM/yyyy"
                                data-testid="date-picker-div-1"
                                style={{ width: "100%" }}
                                maxDate={moment().toDate()}

                            />
                        </div>
                    </div>
                    {myState.handoverDateFlag &&
                        // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
                        <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

                    }

                </Grid>

                <Grid item md={4} lg={4}>
                    <div className={styles.rowDiv}>
                        <div className={clsx(styles.lableDiv)}>
                            <label>To Date</label>
                        </div>
                        <div className={styles.formDiv}>

                            <CustomDatePicker
                                // isMandatory 

                                clearable

                                // markIfUnselected={highlightMandatoryFields}
                                autoOk
                                inputVariant="outlined"
                                value={myState.toDate}
                                onChange={(e) => {


                                    handleDate(e, 'toDate')
                                }}
                                inputProps={{
                                    className: clsx(styles.select, styles.dateInput),

                                }}
                                emptyLabel="dd/mm/yyyy"
                                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                                format="DD/MM/yyyy"
                                data-testid="date-picker-div-1"
                                style={{ width: "100%" }}
                                // maxDate={moment().toDate()}
                                maxDate={moment().toDate()}


                            />
                        </div>
                    </div>
                    {myState.handoverDateFlag &&
                        // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
                        <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

                    }

                </Grid>
                <Grid item md={4} lg={4}>
                    <div className={styles.rowDiv}>

                        <div className={styles.formDiv}>



                            <Button
                                className={clsx(
                                    styles.actionButton,
                                    styles.primaryActionButton,
                                )}
                                variant="primary"
                                //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                                onClick={() => handleViewclick()}
                                //     disabled={(myState.chassisNo == null)}
                                data-testid="confirm-action"
                                style={{ marginRight: "5px" }}

                            >
                                View
                            </Button>

                            <Button
                                className={clsx(styles.actionButton, styles.resetButton)}
                                variant="tertiary"
                                onClick={handleOpen}
                                // onClick={() =>handleCancelclick()}
                                style={{ marginRight: "5px" }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </Grid>
            </Grid>

        </div>
    )

    const renderReport = () => (
        <div className={styles.formGroup}>
            <div className={styles.col2} style={{ width: "100%", height: "300px", }}>
                <Table
                    columns={baseDefaultColumns}
                    defaultColumns={baseDefaultColumns}
                    rowHeight={ROW_HEIGHT}
                    //   rows={tableData}
                    rows={[{ SrNo: "1", BookingDate: "15-4-23", ProjectCode: "W.22.Ev.711", ProjectDescription: "Test Project-Timebooking", Aggregate: "Vehicle", Activity: "Tear Down & Bench Marking", Hours: "2.00", BookingType: "Daily", ApprovalStatus: "PENDDING BOOKING APPROVAL" },
                    { SrNo: "2", BookingDate: "18-4-23", ProjectCode: "NWKO35", ProjectDescription: "Administrative Work", Aggregate: "Aerokit", Activity: "Advance Engg", Hours: "8.75", BookingType: "Batch", ApprovalStatus: "PENDDING BOOKING APPROVAL" }]}
                    setAsnCount={setCount}
                    isDataLoading={false}
                    actionButtons
                // onRowSelect={(e)=> redirectToProjectDetailsPage(e.id)}
                //   primaryAction={{
                //     name: 'Cancel',
                //     authOperation: USER_OPERATIONS.CREATE_PROJECT,
                //     shouldEnable: () => true,
                //     actionFn:  ()=>{downloadData()},                 
                //   }}
                //    onRowSelect={(e) => { console.log('onRowSelect call') }}
                />
            </div>
        </div>
    )
    const getSelectedFields = () => ({
        projectId: selectedProject,
        poNumber: selectedPO,
        commodityGroupId: purchaseCommodity && purchaseCommodity.value,
        aqCommodityGroupId: aqCommodity && aqCommodity.value,
        purchaseBuyerName: inputFields?.purchaseBuyerName,
        kamContactDetails: {
            // id: inputFields,
            name: inputFields?.suppRepresentativeName,
            contactNumber: inputFields?.suppRepresentativeContact,
            emailId: inputFields?.suppRepresentativeEmail
        }
    });

    const validateFields = (fields) => {
        const requiredFields = { ...fields, ...fields.kamContactDetails }
        const hasMissingRequiredFields = Object.values(requiredFields).some(
            (field) => !field
        );

        const hasError = Object.values(errors).some((err) => err);

        if (hasMissingRequiredFields || hasError) {
            return false;
        }
        return true;
    };

    const runPreSubmissionChecks = () => {
        const selectedFields = getSelectedFields();
        const areFieldsValid = validateFields(selectedFields);

        if (!areFieldsValid) {
            setHighlightMandatoryFields(true);
            // return false;
            return true;
        }
        return true;
    };

    const resetAllInputs = () => {
        const inputs = {
            purchaseBuyerName: '',
            suppRepresentativeName: '',
            suppRepresentativeContact: '',
            suppRepresentativeEmail: ''
        }
        dispatch({ type: 'update', field: 'inputFields', value: inputs });
        dispatch({ type: 'update', field: 'errors', value: {} });
    }

    const resetState = () => {
        dispatch({ type: 'reset' });
        resetAllInputs();
        resetTableData();
        setHighlightMandatoryFields(null);
        setResetAllVisitedFields(false);
        changeBackgroundColor('processInfoBg');
    }



    useEffect(() => {
        if (resetAllVisitedFields)
            resetState();
    }, [resetAllVisitedFields])

    return (
        <>
            <div className={clsx(styles.scrollContainer, styles.scrollBar, styles.formContainer)}>
                <CustomFormGroup header='View-Booking-Datewise' body={renderOther()} />
                {
                    tableData.length == 0 &&
                    myState.tableFlag && <CustomFormGroup header='Report Details' body={renderReport()} />
                }
            </div>

            {/* <div className={styles.actionBar}>
        <Button
          className={clsx(styles.actionButton, styles.resetButton)}
          variant="tertiary"
          onClick={handleOpen}
        >
          RESET
        </Button>
        {
          product.allDeatils.singleChassisArray[0].chs_veh_target_dt == null ?

            <AuthChecker operation={USER_OPERATIONS.CREATE_PPAP}>
              {isAuthorized => (
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}
                  variant="primary"
                  //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                  onClick={() => runPreSubmissionChecks() && handleSubmit()}
                  disabled={(myState.chassisNo == null)}
                  data-testid="confirm-action"
                >
                  CONFIRM
                </Button>
              )}

            </AuthChecker> :
            <AuthChecker operation={USER_OPERATIONS.CREATE_PPAP}>
              {isAuthorized => (
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}
                  variant="primary"
                  //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                  onClick={() => handlePrompt2('rows')
                  }
                  disabled={!isAuthorized}
                  data-testid="confirm-action"
                >
                  DELETE
                </Button>
              )}

            </AuthChecker>
        }
      </div> */}

            <ResetModal
                isPopupOpen={isPopupOpen}
                handleClose={handleClose}
                resetFields={resetFields}
            />

            <ResetModal2
                a={confirmModalFlag2}
                handleCase={handleClose2}
                onDelete={() => onDeleteRow2(deleteParam2)}
            />


        </>
    )
}


function ResetModal2({ a, handleCase, onDelete }) {
    return (
        <Dialog
            open={a}
            className={styles.popContainer}
            classes={{
                paper: styles.popupBox,
            }}
            data-testid="reset-popup1"
        >
            <>
                <DialogTitle>
                    <span className={styles.title}>
                        <DeleteIcon style={{ height: '18px', width: '18px' }} />
                        <span className={styles.txt}>Are you sure ?</span>
                    </span>
                </DialogTitle>
                <DialogContent className={styles.content}>
                    <span>
                        Do you want to delete ?
                    </span>
                </DialogContent>
                <DialogActions>
                    <Button
                        className={clsx(
                            styles.actionButton,
                            styles.transparentButton
                        )}
                        onClick={handleCase}
                    >Cancel</Button>
                    <Button
                        className={clsx(
                            styles.actionButton,
                            styles.primaryActionButton,
                        )}
                        variant="primary"
                        onClick={onDelete}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </>
        </Dialog>
    )
}
function ResetModal1({ a, handleCase, onDelete }) {
    return (
        <Dialog
            open={a}
            className={styles.popContainer}
            classes={{
                paper: styles.popupBox,
            }}
            data-testid="reset-popup1"
        >
            <>
                <DialogTitle>
                    <span className={styles.title}>
                        <DeleteIcon style={{ height: '18px', width: '18px' }} />
                        <span className={styles.txt}>Are you sure ?</span>
                    </span>
                </DialogTitle>
                <DialogContent className={styles.content}>
                    <span>
                        Do you want to delete ?
                    </span>
                </DialogContent>
                <DialogActions>
                    <Button
                        className={clsx(
                            styles.actionButton,
                            styles.transparentButton
                        )}
                        onClick={handleCase}
                    >Cancel</Button>
                    <Button
                        className={clsx(
                            styles.actionButton,
                            styles.primaryActionButton,
                        )}
                        variant="primary"
                        onClick={onDelete}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </>
        </Dialog>
    )
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
    return (
        <Dialog
            open={isPopupOpen}
            className={styles.popContainer}
            classes={{
                paper: styles.popupBox,
            }}
            data-testid="reset-popup"
        >
            <>
                <DialogTitle>
                    <span className={styles.title}>
                        <MdReplay style={{ height: '18px', width: '18px' }} />
                        <span className={styles.txt}>Reset</span>
                    </span>
                </DialogTitle>
                <DialogContent className={styles.content}>
                    <span>
                        Are you sure you want to reset the filters?
                    </span>
                </DialogContent>
                <DialogActions>
                    <Button
                        className={clsx(
                            styles.actionButton,
                            styles.transparentButton
                        )}
                        onClick={handleClose}
                    >Cancel</Button>
                    <Button
                        className={clsx(
                            styles.actionButton,
                            styles.primaryActionButton,
                        )}
                        variant="primary"
                        onClick={(e) => {
                            e.preventDefault();
                            handleClose()
                            resetFields()
                        }}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </>
        </Dialog>
    )
}

ViewBookingsDatewise.propTypes = {
    redirectToProcessPage: PropTypes.func
}

ResetModal.propTypes = {
    isPopupOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    resetFields: PropTypes.func.isRequired
}
ResetModal1.propTypes = {
    a: PropTypes.bool.isRequired,
    handleCase: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
}
ResetModal2.propTypes = {
    a: PropTypes.bool.isRequired,
    handleCase: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    product: state.product,
    counter: state.counter.value,
    baseUrl: state.counter.baseUrl,
    auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

    fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
    getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
ViewBookingsDatewise.propTypes = {
    counter: PropTypes.number,
    baseUrl: PropTypes.string,
    product: PropTypes.object,
    auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(ViewBookingsDatewise);


export default withAllowedOperationsProvider(
    App,
    RESOURCE_TYPE.PPAP
);
